export default function NewsletterSection() {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypot && honeypot.value.trim() !== "") {
      return;
    }
    const formData = new FormData(form);
    if (honeypot) formData.delete("website_alt");
    fetch("https://readdy.ai/api/form/d9u4kdd3pcjqs2fcsm3g", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
    })
      .then(async (res) => {
        const text = await res.text();
        try {
          const json = JSON.parse(text);
          if (res.ok && json.code === "OK") {
            alert("感谢您的订阅！我们将定期为您推送亚洲精品推荐。");
            form.reset();
          } else {
            alert("订阅失败，请稍后再试。");
          }
        } catch {
          alert("订阅失败，请稍后再试。");
        }
      })
      .catch(() => {
        alert("网络错误，请稍后再试。");
      });
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
          订阅亚洲精品资讯
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 mb-6 md:mb-8">
          第一时间获取亚洲最新好物推荐、品牌故事和独家优惠信息。
        </p>
        <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <input
            type="email"
            name="email"
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-300 transition-all"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <button
            type="submit"
            className="px-6 py-2.5 text-sm font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer border-none"
          >
            立即订阅
          </button>
        </form>
      </div>
    </section>
  );
}